export const KnockoutValidationSettings = {
    registerExtenders: true,
    decorateInputElement: true,
    parseInputAttributes: true,
    writeInputAttributes: true,
    // Override the default to use Bootstrap 4 error classes
    errorElementClass: 'is-invalid',
    errorMessageClass: 'invalid-tooltip',

    insertMessages: true,
    messagesOnModified: false,
    messageTemplate: null,
    grouping: { live: true }
}